/**
 * @(#)2019/8/26.
 * YxAction，行为组件，用于处理按钮逻辑-参数部分
 * @author 足道
 * Copyright (c) 2019, YUNXI. All rights reserved.
 * YUNXI PROPRIETARY/CONFIDENTIAL. Use is subject to license terms.
 */

/**
 *
 * @param {array || null} group 组信息，如果需要传入一组，那么将参数用数组的形式传入此字段
 * @param {object} iocData 注入数据，当为组传入的时候，参数里的chhildren将被注入此数据
 * @param {any} render 渲染函数，直接渲染自定义节点
 *
 * @param {*} title 按钮提示符
 * @param {string} dataIndex 如果使用了映射值，指定需要匹配枚举映射的字段 ，  如果使用了text，则该字段无效
 * @param {object} data 数据源,跳转或提交的时候都会直接带上
 * @param {string} text 按钮文字
 * @param {object} model 数据模型，用于加工data，参考request的模型功能
 * @param {Function} factory 数据工厂，同上
 * @param {object} requestParam 请求参数
 * @param {object} popconfirmParam 给确认框的参数
 * @param {boolean} isConfirm 是否具有确认功能
 * @param {string} path 跳转路径， jump back 生效
 * @param {string} styleType 样式类型 按钮：button  a标签：link   块标签：tag    图标:icon ,如果用icon，使用type参数来决定用哪个图标
 * @param {string} validateModel 当 actionType 为 submit时起效，defaul 默认/ scroll 自动滚动进可见范围
 * @param {string} actionType action-功能、jump-跳转、back-返回、submit-提交、reset-重置、upload-上传（uploadConfig 可给上传传参）、downFile-下载文件、popup-弹出层(popupParam可给弹窗传参)
 * @param {string} jumpType actionType = jump 时起效，iframe:跳转新页面，router：路由跳转，blank：打开新窗口
 * @param {Function} children(data,{close}) actionType为popup时 ，会给popupParam.children抛出一个close函数，可以在外部主动关闭弹窗 popupParam:{children(data,{close}){}}
 * @param {Function} validateCallback 当 actionType 为 submit时起效,校验通过的回调函数,抛出 ids,values 两参数
 * @param {Function(data){return bool}} beforeClick 点击之前的回调 如果该函数返回false，则action的操作和提交都不会执行
 * @param {Function(data){return bool}} afterClick  点击事件之后的回调
 * @param {array} ids 需要校验或提交的的控件的id组，比如['id1','id2']   当 actionType 为 submit时起效
 * @param {boole} packUp 是否收起折叠
 * @param {object |undefined} validateOptions 验证配置，参考 antd from
 * @param {number} timeOut 延时更新state，默认300ms
 * @param {array} extraTypeList []; // 自己组件定义额外的类型
 * @param {boolean} message 提示语如果要关闭，给message设置为false
 * @param {object} uploadConfig 上传参数
 * @param {object} downConfig 下载配置参数
 * @param {boolean} check 是否开启组件参数校验
 *
 * 行为组件，将逻辑封装到按钮里面
 * @class YxAction
 * @extends {Component}
 */
export default function () {
  return {
    text: null,
    emum: null,
    data: null,
    path: null,
    title: null,
    timeOut: 60,
    message: "",
    titps: null,
    render: null,
    version: null,
    isConfirm: null,
    requestParam: null,
    popconfirmParam: {},
    styleType: "button",
    validateModel: null,
    actionType: "action",
    packUp: false, // 是否收入到收起按钮
    validateOptions: undefined,
    validateCallback: function () {},
  };
}



// WEBPACK FOOTER //
// ./src/yx-widget/component/YxAction/actionParam.js